import BaseService from './BaseService'

class LocationService extends BaseService {
  constructor() {
    super('/locations')
  }

  // Get all locations with optional filtering and pagination
  async getLocations(params = {}) {
    return this.getAll(params)
  }

  // Get a specific location by ID
  async getLocation(id) {
    return this.getById(id)
  }

  // Create a new location
  async createLocation(locationData) {
    return this.create(locationData)
  }

  // Update an existing location
  async updateLocation(id, locationData) {
    return this.update(id, locationData)
  }

  // Delete a location
  async deleteLocation(id) {
    return this.delete(id)
  }
}

export const locationService = new LocationService()
